(function () {
  var invalidMessage = 'Please enter a valid value.';
  var textTypes = {
    text: true,
    search: true,
    tel: true,
    url: true,
    password: true
  };

  function hasMeaningfulText(value) {
    var trimmed = String(value || '').trim();
    if (!trimmed) return false;

    try {
      return /[\p{L}\p{N}]/u.test(trimmed);
    } catch (error) {
      return /[A-Za-z0-9]/.test(trimmed);
    }
  }

  function shouldValidate(field) {
    if (!field || field.disabled || !field.required) return false;

    var tagName = field.tagName ? field.tagName.toLowerCase() : '';
    if (tagName === 'textarea') return true;
    if (tagName !== 'input') return false;

    var type = (field.getAttribute('type') || 'text').toLowerCase();
    return Boolean(textTypes[type]);
  }

  function validateField(field) {
    if (!shouldValidate(field)) return true;

    if (!hasMeaningfulText(field.value)) {
      field.setCustomValidity(invalidMessage);
      return false;
    }

    field.setCustomValidity('');
    return true;
  }

  document.addEventListener('input', function (event) {
    if (shouldValidate(event.target)) {
      validateField(event.target);
    }
  }, true);

  document.addEventListener('blur', function (event) {
    if (shouldValidate(event.target)) {
      validateField(event.target);
    }
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || form.tagName !== 'FORM') return;

    var fields = Array.prototype.slice.call(form.querySelectorAll('input[required], textarea[required]'));
    var invalidField = fields.find(function (field) {
      return shouldValidate(field) && !validateField(field);
    });

    if (!invalidField) return;

    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();

    invalidField.reportValidity();
    invalidField.focus({ preventScroll: false });
  }, true);
})();
